(() => {
  const instances = new Map();
  const STORAGE_KEY_PREFIX = "aw_floating_banner_closed_";

  class AWFloatingBanner {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId || "default";
      this.closeButton = root.querySelector("[data-aw-floating-banner-close]");
      this.storageKey = `${STORAGE_KEY_PREFIX}${this.sectionId}`;

      this.onClose = this.onClose.bind(this);

      this.init();
    }

    init() {
      if (this.isClosed()) {
        this.hide();
        return;
      }

      if (this.closeButton) {
        this.closeButton.addEventListener("click", this.onClose);
      }
    }

    destroy() {
      if (this.closeButton) {
        this.closeButton.removeEventListener("click", this.onClose);
      }
    }

    isClosed() {
      try {
        return window.sessionStorage.getItem(this.storageKey) === "true";
      } catch (error) {
        return false;
      }
    }

    setClosed() {
      try {
        window.sessionStorage.setItem(this.storageKey, "true");
      } catch (error) {
        // sessionStorageが使えない場合は何もしない
      }
    }

    hide() {
      this.root.classList.add("is-hidden");
    }

    onClose(event) {
      event.preventDefault();
      event.stopPropagation();

      this.setClosed();
      this.hide();
    }
  }

  const init = (container = document) => {
    container.querySelectorAll("[data-aw-floating-banner]").forEach((root) => {
      if (instances.has(root)) return;

      instances.set(root, new AWFloatingBanner(root));
    });
  };

  const destroy = (container) => {
    container.querySelectorAll("[data-aw-floating-banner]").forEach((root) => {
      const instance = instances.get(root);
      if (!instance) return;

      instance.destroy();
      instances.delete(root);
    });
  };

  document.addEventListener("DOMContentLoaded", () => init());

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    destroy(event.target);
  });
})();
